import { Component, OnInit, OnDestroy, Input, SimpleChanges } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { IComponent } from "../../interfaces";

// services
import * as srv from "../../services";
import { environment } from "../../../../environments/environment.nathan";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
	selector: "app-levels",
	templateUrl: "./levels.component.html",
	styleUrls: ["./levels.component.scss"]
})
export class LevelsComponent implements IComponent, OnInit, OnDestroy {
	// implement icomponent
	name = "LevelsComponent";
	subscriptions: Subscription[] = [];

	@Input() NOLEVEL: number = 0;

	@Input() DISABlE_LEVEL1: boolean = false;

	@Input() DISABlE_LEVEL2: boolean = false;

	@Input() DISABlE_LEVEL3: boolean = false;

	// implement local
	level1: boolean;
	level2: boolean;
	level3: boolean;
	level = 0;
	isProdEnv: boolean = environment.production;
	//nolevel: Number = 0;

	constructor(
		private _logSrv: srv.LogService,
		private _applicationSrv: srv.ApplicationService
	) { }

	ngOnInit() { }

	ngOnChanges(changes: SimpleChanges): void {
		this.level = 0;
		if (this.DISABlE_LEVEL1 == false && this.DISABlE_LEVEL2 == true && this.DISABlE_LEVEL3 == true) {
			this.level = 1;
		}
		else if (this.DISABlE_LEVEL2 == false && this.DISABlE_LEVEL1 == true && this.DISABlE_LEVEL3 == true) {
			this.level = 2;
		}
		else if (this.DISABlE_LEVEL3 == false && this.DISABlE_LEVEL1 == true && this.DISABlE_LEVEL2 == true) {
			this.level = 3;
		}

		this.OnCheckBoxClicked(this.level, false);

	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(function (s) {
			s.unsubscribe();
		});
		delete this.subscriptions;
	}

	OnCheckBoxClicked(level: number, fromCheckBoxCtrl: boolean = true) {
		this._logSrv.Debug(this.name, ["OnCheckBoxClicked", level]);
		if (+this.level === +level && fromCheckBoxCtrl) {
			this.level = 0;
			this.level1 = this.level2 = this.level3 = false;
		} else {
			this.level = +level;
			switch (+level) {
				case 1:
					this.level2 = this.level3 = false;
					this.level1 = true;
					break;
				case 2:
					this.level1 = this.level3 = false;
					this.level2 = true;
					break;
				case 3:
					this.level2 = this.level1 = false;
					this.level3 = true;
					break;
			}
		}
		this._applicationSrv.Level = this.level;
		this._logSrv.Debug(this.name, [
			"OnCheckBoxClicked",
			{ l1: this.level1, l2: this.level2, l3: this.level3 }
		]);
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/levels/levels.component.ts